import { TableRow, unit, themeGet } from '@pocketlaw/tetris';
import styled, { css } from 'styled-components';
const borderStyles = css `
  ${unit(0.25)} dashed ${themeGet('colors.brandPrimary.500')} !important;
`;
const draggingOverStyles = css `
  > td {
    border-top: ${borderStyles};
    border-bottom: ${borderStyles};
  }

  > td:first-child {
    border-left: ${borderStyles};
  }

  > td:last-child {
    border-right: ${borderStyles};
  }
`;
export const StyledTableRow = styled(TableRow) `
  ${({ $isDraggable }) => $isDraggable && 'cursor: grab;'};
  ${({ $isDragging }) => $isDragging && 'cursor: grabbing;'};

  > td:first-child {
    border-left: ${unit(0.25)} solid transparent;
  }

  > td:last-child {
    border-right: ${unit(0.25)} solid transparent;
  }

  ${({ $isDraggingOver }) => $isDraggingOver && draggingOverStyles};
`;
